<template>
  <div class="check-plateform">
    <!--标题-->
    <div class="region-title">查看店铺</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="100px">
        <el-form-item label="店铺号:">
          <span>{{ basicInfo.code }}</span>
        </el-form-item>
        <!-- <el-form-item label="业务:"> {{ basicInfo.salesman ? basicInfo.salesman.fullName : '' }} </el-form-item> -->
        <el-form-item label="店铺名称:"> {{ basicInfo.shopName }} </el-form-item>
        <!-- <el-form-item label="公司名称:"> {{ basicInfo.companyName }} </el-form-item> -->
        <el-form-item label="手机号:"> {{ basicInfo.phone }} </el-form-item>
        <!-- <el-form-item label="公司地区:"> {{ basicInfo.address ? basicInfo.address.province : '' }}{{ basicInfo.address ? basicInfo.address.city : '' }}{{ basicInfo.address ? basicInfo.address.county : ''
        }} </el-form-item> -->
        <el-form-item label="地址:"> {{ basicInfo.address ? basicInfo.address.completeAddress : '' }} </el-form-item>
        <!-- <el-form-item label="营业执照:">
          <el-image style="max-width:200px" v-if="basicInfo.licenseUrl !== undefined && basicInfo.licenseUrl !== ''" class="yingye" :src="basicInfo.licenseUrl"
            :preview-src-list="[basicInfo.licenseUrl]"></el-image>
        </el-form-item> -->
        <el-form-item label="套餐类型:"> {{ basicInfo.splitImagesOrders.length > 0 ? basicInfo.splitImagesOrders[0].name : '' }} </el-form-item>
        <el-form-item label="会员状态:">
          <span v-for="(item, index) in statusList" :key="index">{{ basicInfo.status == item.value ? item.label : '' }}</span>
          <!-- <el-select v-model="basicInfo.storeTypeBean.id" placeholder="请选择" disabled class="customer-select">
            <el-option :label="item.name" :value="item.id" v-for="item in platformType" :key="item.id"></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="会员开始日期:"> {{ basicInfo.startTime }} </el-form-item>
        <el-form-item label="会员结束日期:"> {{ basicInfo.expireTime }} </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>
<script>
import { queryMembershipById } from '@/api/crm'
export default {
  name: 'check-plateform',
  data () {
    return {
      storeMsg: {},
      statusList: [{
        value: 0,
        label: '非会员'
      }, {
        value: 1,
        label: '会员'
      },
      {
        value: 2,
        label: '过期会员'
      },
      {
        value: 3,
        label: '即将过期会员'
      }
      ],
      checkTrueDialog: false,
      checkType: '',
      checkDialog: false,
      basicInfo: {
        address: {
          // fullAddress: ''
        },
        storeTypeBean: {
          id: null
        }
      },
      platformType: [],
      isRepeat: false,
      isCheckedRepeat: false
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    let id = this.$route.query.id
    queryMembershipById(id).then((res) => {
      if (res.data.success) {
        this.basicInfo = res.data.data
        this.basicInfo.phone = this.$msg.filterBridal(res.data.data.phone)
      }
    })
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
